import { ADDRESS_INFO } from '../../pages/jobsPage/config';
import { isEmpty } from '../../../utility/validation';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit-dark.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-outlined.svg';

export const getMoveCandidateToStepActionItems = (
  steps,
  candidateStep,
  onMoveToStep
) =>
  steps.map(step => {
    return {
      type: step.title,
      label: step.title,
      action: () => onMoveToStep(step),
      shouldItemRender: () => step.id !== candidateStep,
    };
  });

export const CANDIDATE_NAVIGATIONS = {
  PROFILE: 'profile',
  TIMELINE: 'timeline',
  COMMUNICATION: 'communication',
  REVIEWS: 'reviews',
  COMMENTS: 'comments',
};

export const getAddress = user => {
  if (
    !user[ADDRESS_INFO.ADDRESS] &&
    !user[ADDRESS_INFO.CITY] &&
    !user[ADDRESS_INFO.COUNTRY]
  )
    return '-';

  const fullAddress = Object.values(ADDRESS_INFO).reduce((acc, curr) => {
    if (user[curr] && !isEmpty(acc)) return user[curr];

    return user[curr] && isEmpty(acc) ? `${acc}, ${user[curr]}` : acc;
  }, '');

  return fullAddress;
};

export const getMenuItems = (record, translations, onEdit, onDelete) => {
  return [
    {
      type: 'edit',
      label: translations.menuItemLabels.edit,
      shouldItemRender: () => true,
      action: () => onEdit(record),
      icon: EditIcon,
    },
    {
      type: 'delete',
      label: translations.menuItemLabels.delete,
      shouldItemRender: () => true,
      action: () => onDelete(record),
      icon: DeleteIcon,
    },
  ];
};

export const TIMELINE_MAP = {
  REVIEW: 'review',
  COMMENT: 'note',
  COMMUNICATION: 'message',
  JOB_EVENT: 'job_event',
};
